'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var ESCAPE_KEY_VALUE = 'Escape';
var LEFT_MOUSE_BUTTON_VALUE = 0;
var useCloseable = function (_a) {
    var closeableRef = _a.closeableRef, closeFunction = _a.closeFunction, _b = _a.shouldStopListening, shouldStopListening = _b === void 0 ? false : _b;
    var close = function (event) {
        if (event instanceof KeyboardEvent && event.key === ESCAPE_KEY_VALUE) {
            closeFunction();
        }
        else if (event instanceof MouseEvent &&
            event.button === LEFT_MOUSE_BUTTON_VALUE &&
            (closeableRef.current && !closeableRef.current.contains(event.target))) {
            // See here: https://stackoverflow.com/a/43851475 - for explanation of above type assertion
            closeFunction();
        }
    };
    var addListeners = function () {
        window.addEventListener('keydown', close);
        window.addEventListener('mousedown', close);
    };
    var removeListeners = function () {
        window.removeEventListener('keydown', close);
        window.removeEventListener('mousedown', close);
    };
    react.useEffect(function () {
        if (shouldStopListening) {
            removeListeners();
        }
        else {
            addListeners();
        }
        return removeListeners;
    }, [shouldStopListening]);
};

exports.useCloseable = useCloseable;
